/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/


import {
   FETCH_BANNER_DETAILS_REQUEST,
   FETCH_BANNER_DETAILS_SUCCESS,
   FETCH_BANNER_DETAILS_FAILURE,
   FETCH_BANNER_DELETE_REQUEST,
   FETCH_BANNER_DELETE_SUCCESS,
   FETCH_BANNER_DELETE_FAILURE
  } from "./bannerUploadTypes";
  
  const initialState = {
    loading: false,
    banners: {},
    error: "",
  };
  
  const bannerDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_BANNER_DETAILS_REQUEST:
          return {
            ...state,
            loading: true,
          };
        
      case FETCH_BANNER_DETAILS_SUCCESS:
        return {
          loading: false,
          banners: action.payload,
          error: "",
        };
      case FETCH_BANNER_DETAILS_FAILURE:
        return {
          loading: false,
          banners: {},
          error: action.payload,
        };

      case FETCH_BANNER_DELETE_REQUEST:
        return{
          loading:true,
          banners:{},
          error:false
        };
      
        case FETCH_BANNER_DELETE_SUCCESS:
          return{
            loading:false,
            banners:{},
            error:""
          } 
          case FETCH_BANNER_DELETE_FAILURE:
          return{
            loading:false,
            banners:{},
            error:action.payload
          } 
      default:
        return state;
    }
  };
  
  export default bannerDetailsReducer;
  